import React, { useState } from "react";
import axios from "../../libs/axios.lib";
import { getUser } from "../../utils/login.utils";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import LinearProgress from "@mui/material/LinearProgress";
import base_url from "../../constants/base_url";

export default function UploadTemp() {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const handleFileChange = (e) => {
    setFile(e.target.files?.[0] || null);
    setResult(null);
    setError(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) return;

    setUploading(true);
    setProgress(0);
    setResult(null);
    setError(null);

    const fd = new FormData();
    fd.append("video", file);

    try {
      const token = getUser()?.token;

      const resp = await axios.post("videos/upload-temp", fd, {
        headers: token ? { Authorization: token } : {},
        onUploadProgress: (progressEvent) => {
          if (progressEvent.total) {
            const percent = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setProgress(percent);
          }
        },
        timeout: 0, // allow long processing
      });

      // Backend should return either a direct download URL or a filename
      const data = resp.data || {};
      if (data.processed_download_url) {
        setResult({ url: data.processed_download_url });
      } else if (data.filename) {
        setResult({ url: base_url + "videos/uploads/" + data.filename });
      } else {
        setResult({ raw: data });
      }
    } catch (err) {
      setError(
        err?.response?.data?.message || err?.message || "Upload failed"
      );
    } finally {
      setUploading(false);
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h6" mb={2}>
        Temporary Video Upload (hidden)
      </Typography>

      <form onSubmit={handleSubmit}>
        <input type="file" accept="video/*" onChange={handleFileChange} />
        <Box mt={2}>
          <Button type="submit" variant="contained" disabled={!file || uploading}>
            Upload
          </Button>
        </Box>
      </form>

      {uploading && (
        <Box mt={2} sx={{ width: "100%" }}>
          <LinearProgress variant="determinate" value={progress} />
          <Typography variant="body2" mt={1}>{progress}%</Typography>
        </Box>
      )}

      {result && (
        <Box mt={3}>
          <Typography variant="subtitle1">Processed result:</Typography>
          {result.url ? (
            <a href={result.url} target="_blank" rel="noreferrer">
              Download processed video
            </a>
          ) : (
            <pre style={{ whiteSpace: "pre-wrap" }}>{JSON.stringify(result.raw, null, 2)}</pre>
          )}
        </Box>
      )}

      {error && (
        <Box mt={2}>
          <Typography color="error">{error}</Typography>
        </Box>
      )}
    </Box>
  );
}
